define('views/components/distributor_manager/distributor_manager_list',['require','views/base/list_view','views/components/distributor_manager/distributor_manager','text!templates/components/distributor_manager/distributor_manager_list.html'],function(require){

    var BaseListView = require('views/base/list_view');
    var ChildView = require('views/components/distributor_manager/distributor_manager');

    var temp = require("text!templates/components/distributor_manager/distributor_manager_list.html");
    return BaseListView.extend({
        template: _.template(temp),
        childView: ChildView
    });
});

